module.exports = __webpack_public_path__ + "img/icon-delete.f14e15c5.png";